import classNames from 'classnames'

import { MyMonitoringUserModifyModal } from '@apps-common/apps/portal/pages/my-monitoring/pages/details/components'
import { CardContainer } from '@apps-common/components/common'
import { PageSubtitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundSm, INPUT_INFO_SM_NO_BORDER, InputInfoSM } from '@apps-common/components/elements'
import { VertSpacerLg } from '@apps-common/components/layout'
import { MODAL_BUTTON_ROUNDED_STYLES, ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { valueStringCheck } from '@apps-common/helpers/value-string-check'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IMyMonitoringAccountModel } from '@apps-common/types/portal/my-monitoring'

interface IProps {
  loading?: boolean
  disabled?: boolean
  data?: IMyMonitoringAccountModel
}

export const MyMonitoringAccountDetailsCard: React.FC<IProps> = ({ loading, disabled, data }) => {
  const { id, email, firstName, lastName, fullName, phoneNumber } = data || {}

  return (
    <CardContainer bgClasses='bg-surface border border-border'>
      <div className='flex items-center justify-between px-[5px]'>
        <PageSubtitle classes='text-text'>Details</PageSubtitle>
        <ModalButton
          component={MyMonitoringUserModifyModal}
          disabled={loading || disabled}
          componentProps={{ userId: id }}
          enterAnimation={modalSlideUpEnterAnimation}
          leaveAnimation={modalSlideUpLeaveAnimation}
          backdropDismiss
          classes={classNames(MODAL_BUTTON_ROUNDED_STYLES, 'bg-secondary-content/5')}
        >
          <ButtonRoundSm type='div' className='action-neutral'>
            <commonIcons.edit />
          </ButtonRoundSm>
        </ModalButton>
      </div>
      <VertSpacerLg />
      <div className='grid sm:grid-cols-2 gap-x-[20px]'>
        <InputInfoSM
          id='email'
          label='Email'
          showLabel
          labelClassName='ml-0 mb-1 rounded-sm jost-medium'
          className={INPUT_INFO_SM_NO_BORDER}
          loading={loading}
          hideNoEditIcon
          value={email}
        />
        <InputInfoSM
          id='fullName'
          label='Full name'
          showLabel
          labelClassName='ml-0 mb-1 rounded-sm jost-medium'
          className={INPUT_INFO_SM_NO_BORDER}
          loading={loading}
          hideNoEditIcon
          value={fullName}
        />
        <InputInfoSM
          id='firstName'
          label='First name'
          showLabel
          labelClassName='ml-0 mb-1 rounded-sm jost-medium'
          className={INPUT_INFO_SM_NO_BORDER}
          loading={loading}
          hideNoEditIcon
          value={firstName}
        />
        <InputInfoSM
          id='lastName'
          label='Last name'
          showLabel
          labelClassName='ml-0 mb-1 rounded-sm jost-medium'
          className={INPUT_INFO_SM_NO_BORDER}
          loading={loading}
          hideNoEditIcon
          value={lastName}
        />
        <InputInfoSM
          id='phoneNumber'
          label='Phone'
          showLabel
          labelClassName='ml-0 mb-1 rounded-sm jost-medium'
          className={INPUT_INFO_SM_NO_BORDER}
          loading={loading}
          hideNoEditIcon
          value={valueStringCheck(phoneNumber)}
        />
        <InputInfoSM
          id='role'
          label='Phone'
          showLabel
          labelClassName='ml-0 mb-1 rounded-sm jost-medium'
          className={INPUT_INFO_SM_NO_BORDER}
          loading={loading}
          hideNoEditIcon
          value={valueStringCheck(phoneNumber)}
        />
      </div>
    </CardContainer>
  )
}
